import React, { useState } from 'react';
import content from '../../content/content';

import imgDeans3956 from '../../images/achievements/Deans Awards/IMG_3956.jpg';
import imgDeans3955 from '../../images/achievements/Deans Awards/IMG_3955.jpg';
import imgDeans3951 from '../../images/achievements/Deans Awards/IMG_3951.jpg';
import imgDeans3965 from '../../images/achievements/Deans Awards/IMG_3965.jpg';
import imgDeans3959 from '../../images/achievements/Deans Awards/IMG_3959.jpg';
import imgPythonCert    from '../../images/achievements/HackerRank/Python (Basic) Certificate.png';
import imgProbSolvBasic from '../../images/achievements/HackerRank/Problem Solving (Basic) Certificate.png';
import imgProbSolvInter from '../../images/achievements/HackerRank/Problem Solving (Intermediate) Certificate.png';
import imgRestAPI       from '../../images/achievements/HackerRank/Rest API (Intermediate) Certificate.png';
import imgLinkedInDjango     from '../../images/achievements/LinkedIn Learning/CertificateOfCompletion_Learning Django.jpg';
import imgLinkedInGoEss      from '../../images/achievements/LinkedIn Learning/CertificateOfCompletion_Go Essentials Concurrency Connectivity and HighPerformance Apps.jpg';
import imgLinkedInLearningGo from '../../images/achievements/LinkedIn Learning/CertificateOfCompletion_Learning Go.jpg';
import imgLinkedInAdvancedGo from '../../images/achievements/LinkedIn Learning/CertificateOfCompletion_Advanced Go Programming Data Structures Code Architecture and Testing.jpg';
import imgBS23GenAI          from '../../images/achievements/Brain Station 23/Gen AI E1 Fundamentals - Unlocking the Future.png';
import imgBS23AntiCorruption  from '../../images/achievements/Brain Station 23/Anti-Corruption and Anti-Bribery Policy.png';
import imgBS23CyberSecurity   from '../../images/achievements/Brain Station 23/Cyber Security and Physical Protection.png';
import imgBS23DigitalAssets   from '../../images/achievements/Brain Station 23/Digital Assets Security and Privacy.png';
import imgBS23Occupational    from '../../images/achievements/Brain Station 23/Occupational Safety for Fire and Earthquake.png';
import imgBS23CMMI            from '../../images/achievements/Brain Station 23/CMMI_Foundations.jpg';
import imgBadge50Days  from '../../images/achievements/LeetCode/download (1).png';
import imgBadge100Days from '../../images/achievements/LeetCode/download.png';

const imageMap = {
  'Deans Awards/IMG_3956.jpg':                       imgDeans3956,
  'Deans Awards/IMG_3955.jpg':                       imgDeans3955,
  'Deans Awards/IMG_3951.jpg':                       imgDeans3951,
  'Deans Awards/IMG_3965.jpg':                       imgDeans3965,
  'Deans Awards/IMG_3959.jpg':                       imgDeans3959,
  'HackerRank/Python (Basic) Certificate.png':                  imgPythonCert,
  'HackerRank/Problem Solving (Basic) Certificate.png':         imgProbSolvBasic,
  'HackerRank/Problem Solving (Intermediate) Certificate.png':  imgProbSolvInter,
  'HackerRank/Rest API (Intermediate) Certificate.png':         imgRestAPI,
  'LinkedIn Learning/CertificateOfCompletion_Learning Django.jpg':                                                                        imgLinkedInDjango,
  'LinkedIn Learning/CertificateOfCompletion_Go Essentials Concurrency Connectivity and HighPerformance Apps.jpg':                        imgLinkedInGoEss,
  'LinkedIn Learning/CertificateOfCompletion_Learning Go.jpg':                                                                           imgLinkedInLearningGo,
  'LinkedIn Learning/CertificateOfCompletion_Advanced Go Programming Data Structures Code Architecture and Testing.jpg':                  imgLinkedInAdvancedGo,
  'Brain Station 23/Gen AI E1 Fundamentals - Unlocking the Future.png':    imgBS23GenAI,
  'Brain Station 23/Anti-Corruption and Anti-Bribery Policy.png':           imgBS23AntiCorruption,
  'Brain Station 23/Cyber Security and Physical Protection.png':            imgBS23CyberSecurity,
  'Brain Station 23/Digital Assets Security and Privacy.png':               imgBS23DigitalAssets,
  'Brain Station 23/Occupational Safety for Fire and Earthquake.png':       imgBS23Occupational,
  'Brain Station 23/CMMI_Foundations.jpg':                                  imgBS23CMMI,
  'LeetCode/download (1).png':                                   imgBadge50Days,
  'LeetCode/download.png':                                       imgBadge100Days,
};

const getImage = (file) => imageMap[file];

const categoryColors = {
  Academic:            'bg-indigo-100 text-indigo-700',
  HackerRank:          'bg-green-100 text-green-700',
  'LinkedIn Learning': 'bg-blue-100 text-blue-700',
  'Brain Station 23':  'bg-purple-100 text-purple-700',
  'Company Training':  'bg-orange-100 text-orange-700',
  Badges:              'bg-yellow-100 text-yellow-700',
};

export default function Achievements() {
  const { categories, items } = content.achievements;
  const [active, setActive] = useState('Academic');
  const [modal, setModal] = useState(null);

  const filtered = items.filter(i => i.category === active);
  const certs  = filtered.filter(i => i.type === 'certificate');
  const badges = filtered.filter(i => i.type === 'badge');

  return (
    <div id="achievements" className="min-h-screen bg-skill py-16 px-4 sm:px-12 md:px-24">
      <h1 className="text-4xl font-semibold font-nunito text-center p-6 mb-8">
        Achievements
        <br />
        <span className="w-8 h-1 bg-indigo-600 inline-block rounded-full" />
      </h1>

      {/* Filter tabs */}
      <div className="flex flex-wrap justify-center gap-2 mb-12">
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-200 border
              ${active === cat
                ? 'bg-indigo-600 text-white border-indigo-600'
                : 'bg-white text-gray-600 border-gray-300 hover:border-indigo-400 hover:text-indigo-600'
              }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Certificate cards */}
      {certs.length > 0 && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {certs.map(item => (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              data-aos="zoom-in"
              data-aos-duration="1200"
              onClick={() => setModal(item)}
            >
              <div className="h-44 overflow-hidden bg-gray-100">
                <img
                  src={getImage(item.file)}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${categoryColors[item.category] || 'bg-gray-100 text-gray-600'}`}>
                  {item.category}
                </span>
                <h3 className="text-base font-semibold mt-2 text-gray-800">{item.title}</h3>
                <p className="text-sm text-indigo-600 font-medium">{item.subtitle}</p>
                <p className="text-xs text-gray-400 mt-0.5">{item.meta}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Badges strip */}
      {badges.length > 0 && (
        <>
          <div className="flex flex-wrap justify-center gap-8">
            {badges.map(item => (
              <div
                key={item.id}
                className="flex flex-col items-center gap-2"
                data-aos="zoom-in"
                data-aos-duration="1200"
              >
                <div onClick={() => setModal(item)} className={`w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer ${item.subtitle === 'LeetCode' ? 'overflow-hidden' : 'p-2'}`}>
                  <img
                    src={getImage(item.file)}
                    alt={item.title}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <span className="text-xs font-medium text-gray-600 text-center w-28 leading-tight">{item.title}</span>
                <span className="text-xs text-gray-400">{item.subtitle}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Lightbox modal */}
      {modal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setModal(null)}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={() => setModal(null)}
              className="absolute top-3 right-3 z-10 bg-white/90 hover:bg-white rounded-full w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 shadow text-lg leading-none"
            >
              ✕
            </button>
            <img
              src={getImage(modal.file)}
              alt={modal.title}
              className="w-full object-contain max-h-[70vh]"
            />
            <div className="p-4 border-t">
              <h3 className="font-semibold text-gray-800">{modal.title}</h3>
              <p className="text-sm text-indigo-600">{modal.subtitle}</p>
              <p className="text-xs text-gray-400">{modal.meta}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
